// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__36NVO","footer":"ReportModalFilter_footer__18zYg"};